export * from '../generated/prisma/browser'
